/** localStorage keys for persisted authentication data */
export const AUTH_STORAGE_KEYS = {
  TOKEN: "user_token",
  USER_DATA: "user_data",
} as const;
